var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelpButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 18.7501H13.125V13.7501H14.375C14.8695 13.7501 15.3528 13.6034 15.7639 13.3287C16.1751 13.054 16.4955 12.6636 16.6847 12.2068C16.8739 11.75 16.9234 11.2473 16.827 10.7623C16.7305 10.2774 16.4924 9.83193 16.1428 9.4823C15.7931 9.13267 15.3477 8.89457 14.8627 8.79811C14.3778 8.70164 13.8751 8.75115 13.4183 8.94037C12.9615 9.12959 12.571 9.45002 12.2963 9.86114C12.0216 10.2723 11.875 10.7556 11.875 11.2501H9.375C9.3743 10.3147 9.63597 9.39797 10.1303 8.60393C10.6246 7.80989 11.3317 7.17042 12.1713 6.75818C13.0109 6.34594 13.9492 6.17746 14.8798 6.27189C15.8103 6.36631 16.6957 6.71986 17.4354 7.29235C18.175 7.86484 18.7393 8.63333 19.064 9.51048C19.3887 10.3876 19.4609 11.3383 19.2723 12.2544C19.0838 13.1705 18.642 14.0154 17.9973 14.693C17.3525 15.3706 16.5306 15.8537 15.625 16.0876V18.7501Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 21.25H13.125V23.75H15.625V21.25Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5125 30H1.25V0H25.5125L27.5 1.9875V28.0125L25.5125 30ZM3.75 27.5H24.4875L25 26.9875V3.0125L24.4875 2.5H3.75V27.5Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13.75H0V16.25H5V13.75Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6.25H0V8.75H5V6.25Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21.25H0V23.75H5V21.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpButton);
export default __webpack_public_path__ + "static/media/help_button.5884f55d7fd50a3ae1faafa952a7fc73.svg";
export { ForwardRef as ReactComponent };